import LocationCard from '@/components/locations/LocationCard'
import { AdminPageHeader } from '@/components/patterns/admin-page'
import CreateActionButton from '@/components/patterns/create-action-button'
import { Button } from '@/components/ui/button'
import { Typography } from '@/components/ui/typography'
import { usePathHelper } from '@/hooks/usePathHelper'
import { Can } from '@/lib/casl'
import {
  locationFilters,
  locationQueries,
  useLocations,
} from '@/lib/services/locations/locations.query'
import { createFileRoute, Link, notFound } from '@tanstack/react-router'
import { MapPin } from 'lucide-react'

const filters = locationFilters().get()

export const Route = createFileRoute('/_authenticated/$orgId/settings/locations/')({
  component: RouteComponent,
  loader: ({ context, params }) => {
    if (!context.ability.can('list', 'locations')) throw notFound()
    void context.queryClient.ensureQueryData(
      locationQueries.index({ organizationId: params.orgId, filters })
    )
    return { isReadOnly: !context.ability.can('edit', 'locations') }
  },
})

export function RouteComponent() {
  const { data: locations = [] } = useLocations({ filters })
  const { show, create } = usePathHelper().locations

  return (
    <div className="space-y-4">
      <AdminPageHeader
        icon={MapPin}
        title="Locations"
        actions={
          <Can I="create" a="locations">
            <CreateActionButton asChild>
              <Link to={create().href}>Create New Location</Link>
            </CreateActionButton>
          </Can>
        }
      />

      {locations.length > 0 ? (
        <div className="flex flex-row gap-6 flex-wrap">
          {locations.map((location) => (
            <div className="max-w-lg w-full" key={location.id}>
              <Can do="view" on="locations" passThrough>
                {(allowed) =>
                  allowed ? (
                    <LocationCard location={location} {...show(location.id).link} />
                  ) : (
                    <LocationCard location={location} disabled={true} />
                  )
                }
              </Can>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-12">
          <Typography variant="supporting">No locations found.</Typography>
          <div className="mt-4">
            <Link {...create().link}>
              <Button variant="outline">
                <Typography variant="label">Create your first location</Typography>
              </Button>
            </Link>
          </div>
        </div>
      )}
    </div>
  )
}
